export { FrontCapabilities as default } from '@signageos/common-types/dist/Device/Capabilities/FrontCapability';
